import IOSInstall from "../../../../contents/docs/integrate/_snippets/install-ios.mdx";
import IOSIdentify from "../../../../contents/docs/libraries/ios/_snippets/identify.mdx";
import IOSSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-ios.mdx";
import * as React from 'react';
export default {
  IOSInstall,
  IOSIdentify,
  IOSSendEvents,
  React
};